import { createContext } from 'react'

import type { ButtonProps } from './props.ts'

export const ButtonContext = createContext<Pick<ButtonProps, 'disabled' | 'variant' | 'size'>>({})
